/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ServiceAccountsControllerDeleteAllKeysMutationResponse, ServiceAccountsControllerDeleteAllKeysPathParams, ServiceAccountsControllerDeleteAllKeys401, ServiceAccountsControllerDeleteAllKeys403, ServiceAccountsControllerDeleteAllKeys404 } from "../../models/serviceAccountsController/ServiceAccountsControllerDeleteAllKeys";

function getServiceAccountsControllerDeleteAllKeysUrl(orgId: ServiceAccountsControllerDeleteAllKeysPathParams["orgId"]) {
  const res = { method: 'DELETE', url: `/api/v1/organizations/${orgId}/api-keys` as const }  
  return res
}

/**
 * @description Atomically revokes the organization’s active keys. Returns 204 even when no keys or service account exist. Preserves the account and API version pin. Available to authorized human administrators while API access is disabled, provided the feature flag is enabled. Creation is serialized with revocation; a key created afterward remains valid.
 * @summary Revoke all active service account keys
 * {@link /api/v1/organizations/:orgId/api-keys}
 */
export async function serviceAccountsControllerDeleteAllKeys(orgId: ServiceAccountsControllerDeleteAllKeysPathParams["orgId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ServiceAccountsControllerDeleteAllKeysMutationResponse, ResponseErrorConfig<ServiceAccountsControllerDeleteAllKeys401 | ServiceAccountsControllerDeleteAllKeys403 | ServiceAccountsControllerDeleteAllKeys404>, unknown>({ method : "DELETE", url : getServiceAccountsControllerDeleteAllKeysUrl(orgId).url.toString(), ... requestConfig })  
  return res.data
}